// src/features/tasks/components/TaskListPage/TasksDataGrid/components/AssigneeCell.jsx
import React, { useState } from 'react';
import { Stack, Box, Typography, Chip, AvatarGroup } from '@mui/material';
import ProfilePicture from '../../../../../../components/common/ProfilePicture';

export default function AssigneeCell({ value, row }) {
  const [isHovered, setIsHovered] = useState(false);

  const primaryAssignee = row.primary_assignee;
  const secondaryAssignee = row.secondary_assignee;

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        position: 'relative',
        cursor: 'pointer',
        padding: '4px',
        minHeight: '32px',
        width: '100%'
      }}
    >
      {/* Collapsed view - AvatarGroup */}
      <Box sx={{
        opacity: isHovered ? 0 : 1,
        transition: 'opacity 0.2s ease-in-out',
        pointerEvents: isHovered ? 'none' : 'auto',
        display: 'flex',
        alignItems: 'center'
      }}>
        <AvatarGroup max={2} sx={{ '& .MuiAvatar-root': { width: 24, height: 24, fontSize: '0.75rem' } }}>
          {primaryAssignee && (
            <ProfilePicture
              profilePictureFileId={primaryAssignee.profile_picture_file_id}
              name={primaryAssignee.name}
              size={24}
              imageSize="32x32"
              color={primaryAssignee?.color}
            />
          )}
          {secondaryAssignee && (
            <ProfilePicture
              profilePictureFileId={secondaryAssignee.profile_picture_file_id}
              name={secondaryAssignee.name}
              size={24}
              imageSize="32x32"
              color={secondaryAssignee?.color}
            />
          )}
        </AvatarGroup>
      </Box>

      {/* Expanded view - Full details */}
      <Box sx={{
        opacity: isHovered ? 1 : 0,
        transition: 'opacity 0.2s ease-in-out',
        position: 'absolute',
        top: -1,
        left: 4,
        pointerEvents: isHovered ? 'auto' : 'none'
      }}>
        <Stack spacing={0.5}>
          {primaryAssignee && (
            <Box display="flex" alignItems="center" gap={1}>
              <ProfilePicture
                profilePictureFileId={primaryAssignee.profile_picture_file_id}
                name={primaryAssignee.name}
                size={20}
                imageSize="32x32"
                color={primaryAssignee?.color}
              />
              <Typography variant="caption" noWrap>
                {primaryAssignee.name}
              </Typography>
              <Chip label="1" size="small" variant="outlined" color="primary" sx={{ height: 16, fontSize: '0.6rem' }} />
            </Box>
          )}
          {secondaryAssignee && (
            <Box display="flex" alignItems="center" gap={1}>
              <ProfilePicture
                profilePictureFileId={secondaryAssignee.profile_picture_file_id}
                name={secondaryAssignee.name}
                size={20}
                imageSize="32x32"
                color={secondaryAssignee?.color}
              />
              <Typography variant="caption" noWrap>
                {secondaryAssignee.name}
              </Typography>
              <Chip label="2" size="small" variant="outlined" color="primary" sx={{ height: 16, fontSize: '0.6rem' }} />
            </Box>
          )}
        </Stack>
      </Box>
    </Box>
  );
}